import { Injectable } from '@angular/core';
import { ScreenStateModel } from '../model/state/screen.state.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ScreenViewModel } from '../model/view-model/screen/screen.view.model';

@Injectable({
  providedIn: 'root'
})
export class ScreenStateService {
  public state: ScreenStateModel = new ScreenStateModel();

  private screen = new BehaviorSubject<ScreenViewModel>(null);
  screenModelChange$: Observable<ScreenViewModel> = this.screen.asObservable();

  public reset(): void {
    this.state.showSeatGroupPopups = {};
    this.state.screeningId = null;
  }

  public resetIfChanged(screeningId) {
    if (this.state.screeningId !== null && this.state.screeningId !== screeningId) {
      this.reset();
      this.state.screeningId = screeningId;
    }
  }

  public setData(model: ScreenViewModel) {
    this.screen.next(model);
  }
}
